/**
 * CohortsPage Messages
 *
 * This contains all the text for the CohortsPage component.
 */
import { defineMessages } from 'react-intl';

const scope = 'app.workspace.cohorts';

export default defineMessages({
  cohort: {
    id: `${scope}.cohort`,
    defaultMessage: 'Class',
  },
  newCohort: {
    id: `${scope}.newCohort`,
    defaultMessage: 'New Class',
  },
  cohorts: {
    id: `${scope}.cohorts`,
    defaultMessage: 'Classes',
  },
  defaultCohortName: {
    id: `${scope}.default.cohortName`,
    defaultMessage: 'Untitled Class',
  },
  listColumnHeaderTextName: {
    id: `${scope}.list.columns.headers.names.Name`,
    defaultMessage: 'Name',
  },
  listColumnHeaderTextDate: {
    id: `${scope}.list.columns.headers.names.Date`,
    defaultMessage: 'Date',
  },
  listColumnHeaderTextStudents: {
    id: `${scope}.list.columns.headers.names.Students`,
    defaultMessage: 'Students',
  },
  listColumnHeaderTextLessons: {
    id: `${scope}.list.columns.headers.names.Lessons`,
    defaultMessage: 'Lessons',
  },
  listColumnHeaderTextInstructors: {
    id: `${scope}.list.columns.headers.names.Instructors`,
    defaultMessage: 'Instructors',
  },
  listMoreOptionDelete: {
    id: `${scope}.list.columns.more.options.Delete`,
    defaultMessage: 'Delete',
  },
  listMoreOptionDuplicate: {
    id: `${scope}.list.columns.more.options.Duplicate`,
    defaultMessage: 'Duplicate',
  },
  listMoreOptionRestart: {
    id: `${scope}.list.columns.more.options.Restart`,
    defaultMessage: 'Restart',
  },
  search: {
    id: `${scope}.search`,
    defaultMessage: 'Search',
  },
  all: {
    id: `${scope}.all`,
    defaultMessage: 'All',
  },
  manualClasses: {
    id: `${scope}.manualClasses`,
    defaultMessage: 'Manual Classes',
  },
  ilabsOndemandClasses: {
    id: `${scope}.ilabsOndemandClasses`,
    defaultMessage: 'iLabs On Demand Classes',
  },
  bvOnDemandClasses: {
    id: `${scope}.bvOnDemandClasses`,
    defaultMessage: 'BV on Demand Classes',
  },
  back: {
    id: `${scope}.back`,
    defaultMessage: 'Back',
  },
});
